var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPen = function SvgPen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5029 5.74255C21.0946 5.55763 21.7401 5.71645 22.1785 6.15484L31.3452 15.3215C31.7836 15.7599 31.9424 16.4054 31.7575 16.9971L27.5908 30.3305C27.416 30.8897 26.9605 31.316 26.3911 31.4535L2.22439 37.2868C1.65999 37.4231 1.06537 37.2558 0.654815 36.8452C0.244262 36.4346 0.0769548 35.84 0.21319 35.2756L6.04652 11.109C6.18399 10.5395 6.61036 10.084 7.16953 9.90922L20.5029 5.74255ZM9.0652 12.8091L4.09339 33.4066L24.6909 28.4348L28.2751 16.9654L20.5346 9.22495L9.0652 12.8091Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8333 24C18.6743 24 20.1667 22.5076 20.1667 20.6667C20.1667 18.8257 18.6743 17.3334 16.8333 17.3334C14.9924 17.3334 13.5 18.8257 13.5 20.6667C13.5 22.5076 14.9924 24 16.8333 24Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1903 20.6667L4.33333 35.5237L1.97631 33.1667L16.8333 18.3097L19.1903 20.6667Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7137 4.25789L23.2519 7.22819L30.2718 14.2482L33.2419 11.7865C33.5955 11.3889 33.5855 10.7679 33.1963 10.3787L27.1213 4.30375C26.7297 3.91207 26.1133 3.90182 25.7137 4.25789ZM23.3134 1.94175C25.0165 0.238598 27.7747 0.243079 29.4784 1.94673L35.5533 8.02164C37.2555 9.72385 37.2576 12.4873 35.5583 14.1867C35.5216 14.2233 35.4832 14.2583 35.4433 14.2914L31.2302 17.7832C30.5678 18.3322 29.5965 18.2869 28.9881 17.6785L19.8215 8.51187C19.2132 7.90354 19.1678 6.93217 19.7168 6.2698L23.2087 2.05672C23.2418 2.01679 23.2767 1.97843 23.3134 1.94175Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pen.b40f0850.svg";
export { ForwardRef as ReactComponent };